var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QRCode from "react-qr-code";
import { generateGoogleReviewLink, generatePlugshareReviewLink, TrackedLinkSource, TrackedLinkFormat, } from "ee-utils";
export var ReviewQRCode = function (_a) {
    var _b, _c;
    var reviewCTA = _a.reviewCTA, chargerOcppId = _a.chargerOcppId;
    var url = null;
    var description = null;
    // Handle Google Review CTA
    if ((_b = reviewCTA.googleReview) === null || _b === void 0 ? void 0 : _b.placeId) {
        url = generateGoogleReviewLink(chargerOcppId, reviewCTA.googleReview.placeId, TrackedLinkSource.CUI_RECEIPT, TrackedLinkFormat.QR, reviewCTA.googleReview.baseUrl);
        description = "Scan to leave a Google review";
    }
    // Handle PlugShare CTA
    else if ((_c = reviewCTA.plugshareReview) === null || _c === void 0 ? void 0 : _c.locationId) {
        url = generatePlugshareReviewLink(chargerOcppId, reviewCTA.plugshareReview.locationId, TrackedLinkSource.CUI_RECEIPT, TrackedLinkFormat.QR, reviewCTA.plugshareReview.baseUrl);
        description = "Scan to share on PlugShare";
    }
    // If no valid CTA, don't render anything
    if (!url || !description) {
        return null;
    }
    // QR code size is driven by general guidelines outlined here:
    // https://electricera.atlassian.net/wiki/spaces/SW/pages/1319108609/QR+Code+Guidelines
    //
    // In particular, we'll want to be at least 2.5 in (=175 pixels on a 70 PPI screen).
    // Our average URL will be 200 characters, so pick medium ECC at this size.
    var qrSizePixels = 175;
    var qrEcc = "M";
    return (_jsxs("div", __assign({ className: "grid h-fit w-fit grid-cols-1 items-center gap-6" }, { children: [_jsx("label", __assign({ className: "font-L1 text-center text-black" }, { children: "Share Your Experience" })), _jsxs("div", __assign({ className: "flex flex-col items-center gap-4" }, { children: [_jsx("div", __assign({ className: "rounded-lg bg-white p-4" }, { children: _jsx(QRCode, { value: url, size: qrSizePixels, level: qrEcc }) })), _jsx("div", __assign({ className: "text-center" }, { children: _jsx("label", __assign({ className: "font-B1 text-black/70" }, { children: description })) }))] }))] })));
};
